import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
  public stringSubject = new Subject<string>();
  passValue(data:any) {
    this.stringSubject.next(data);
  }
}